import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateSimpleStepItem } from "../../api/apiSimpleStepItems";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export function useUpdateSimpleStepItem() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: updateItemMutate, isPending } = useMutation({
        mutationFn: ({ id, data }) => updateSimpleStepItem(id, data),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["simple-step-items"] });
            navigate("/simple-steps");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update simple step item");
        },
    });

    return { updateItemMutate, isPending };
}
